// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vSelect from 'vue-select';
import Toastr from 'vue-toastr';
import { loadProgressBar } from 'axios-progress-bar';
import VuejsDialog from 'vuejs-dialog';
import Loading from 'vue-loading-overlay';
import VeeValidate from 'vee-validate';
import VueSession from 'vue-session';
import BootstrapVue from 'bootstrap-vue'
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
require('@/assets/css/style.css')
import 'axios-progress-bar/dist/nprogress.css';
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import 'bootstrap';
import 'vue-loading-overlay/dist/vue-loading.css';
import store from '@/store'
import firebase from 'firebase';
import Notifications from 'vue-notification';
import moment from 'moment'
import VueCircle from 'vue2-circle-progress'
var VueScrollTo = require('vue-scrollto');
import BackToTop from 'vue-backtotop'

Vue.use(BackToTop)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -100,

})
// jquery
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

let requests = 0;

axios.interceptors.request.use(config => {
  if (requests === 0) {
    NProgress.start();
  }
  requests++;
  return config;
});

axios.interceptors.response.use(
  response => {
    requests--;
    if (requests === 0) {
      NProgress.done();
    }
    return response;
  },
  error => {
    requests--;
    if (requests === 0) {
      NProgress.done();
    }
    return Promise.reject(error);
  }
);

Vue.use(VueSession);
Vue.use(BootstrapVue);
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
});
Vue.component('v-select', vSelect);
Vue.use(BootstrapVue)
Vue.use(Toastr, {
  /* options */
  defaultPosition: 'toast-top-full-width',//'toast-top-center',
  defaultType: 'info',
  defaultTimeout: 4000,
  maxOpened: 1,
});
Vue.use(Loading);
Vue.config.productionTip = false
Vue.config.productionTip = false;

Vue.use(VueCircle)
Vue.use(Notifications)
Vue.use(VuejsDialog, {
  okText: 'Yes',
  cancelText: 'No'
});

Vue.filter('currency', function (value) {
  return parseFloat(value).toFixed(2);
});

Vue.filter('rupee', function (value) {
  return '₹ ' + value;
});

Vue.filter('abs', function (value) {
  if (value)
    return Math.abs(value);
  else
    return value;
});

Vue.filter('numbers', function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else
    return value;
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  } else
    return value;
});
Vue.filter("replaceMinusSymbol", function (value, broker) {
  return value.toString().replaceAll('-', '');
});

Vue.filter('currencyformat', function (value) {
  if (value) {
    return Math.abs(value) > 99999 ? Math.sign(value) * ((Math.abs(value) / 100000).toFixed(2)) + 'L' : (Math.sign(value) * Math.abs(value)).toFixed(2)
  }
});
Vue.filter('mmmddyyyy', function (value) {
  if (value) {
    return moment(String(value)).format('MMM, DD YYYY');
  } else
    return value;
});
Vue.filter('ddmmmyyyy', function (value) {
  if (value) {
    return moment(String(value)).format('DD, MMM YYYY');
  } else
    return value;
});
Vue.filter('smmmddyyyy', function (value) {
  if (value) {
    return moment(String(value.substring(0, 10))).format('MMM, DD YYYY');
  } else
    return value;
});
Vue.filter('capitalize', function (value) {
  if (value) {
    return value.toUpperCase();
  } else
    return value;
});
Vue.filter('PdfDate', (value) => {
  if (value) {
    return moment(String(value)).format('DDMMYYYY');
  }
});
Vue.config.productionTip = false
store.dispatch('CHECK_AUTH').then(() => {
	// stage config
  //  const config = {
  //   apiKey: "AIzaSyBnSA7JC0FYpf2J0VPh0kvif1W0sFTjdBs",
  //   authDomain: "portfoliosmith-india-stage.firebaseapp.com",
  //   databaseURL: "https://portfoliosmith-india-stage-default-rtdb.firebaseio.com",
  //   projectId: "portfoliosmith-india-stage",
  //   storageBucket: "portfoliosmith-india-stage.appspot.com",
  //   messagingSenderId: "752386694783"
  // };

	// prod config
	const config = {
	  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
	  authDomain: "portfoliosmith-india.firebaseapp.com",
	  databaseURL: "https://portfoliosmith-india-default-rtdb.firebaseio.com",
	  projectId: "portfoliosmith-india",
	  storageBucket: "portfoliosmith-india.appspot.com",
	  messagingSenderId: "508218053495",
	  appId: "1:508218053495:web:bb58ae95b880800a540772",
	  measurementId: "G-0JCFKFKE3L"
	};
  firebase.initializeApp(config);
  /* eslint-disable no-new */
  new Vue({
    router,
    store,
    component: { App },
    render: h => h(App)
  }).$mount('#app')
})




// WEBPACK FOOTER //
// ./src/main.js